<template>
  <QuantityCalculator
    :quantity="item.getQuantity()"
    :stockCount="item.getStockCount()"
    :min="item.getMinCount()"
    :max="item.getMaxCount()"
    :onAddEvent="addQuantity"
    :onSubEvent="subQuantity"
  />
</template>

<script>
import QuantityCalculator from '@/presentationals/v2/components/layouts/organisms/QuantityCalculator'

export default {
  name: 'CartProductQuantity',
  components: {
    QuantityCalculator
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    onAddQuantity: {
      type: Function,
      required: true
    },
    onSubQuantity: {
      type: Function,
      required: true
    }
  },
  methods: {
    onActive(callback) {
      setTimeout(() => {
        this.active = true
        callback()
      }, this.debounceTime)

      this.active = false
    },

    async addQuantity() {
      if (!this.active) return

      this.onActive(() => {
        this.onAddQuantity(this.product, this.item)
      })
    },

    async subQuantity() {
      if (!this.active) return

      this.onActive(() => {
        this.onSubQuantity(this.product, this.item)
      })
    }
  },
  data() {
    return {
      active: true,
      debounceTime: 100
    }
  }
}
</script>

<style>
</style>